<template>
  <v-menu ref="menuHelp" v-model="open" offset-y :max-width="maxWidth">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        class="hint__icon mt-2"
        :class="iconClass"
        :size="iconSize"
        v-bind="attrs"
        v-on="on"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    <div>{{ text }}</div>
  </v-menu>
</template>

<script>
export default {
  name: "Hint",
  props: {
    text: {
      type: String,
      required: true
    },
    maxWidth: {
      type: Number,
      default: 450
    },
    iconClass: {
      type: String,
      default: ""
    },
    iconSize: {
      type: Number,
      default: 18
    }
  },
  data() {
    return {
      open: false
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../styles/branding.scss";
.hint__icon {
  color: $brand-control-icon;
  font-size: 18px;
  margin-left: -16px;
}

.v-menu__content {
  background: rgba(97, 97, 97, 0.9);
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  padding: 5px 16px;
  position: absolute;
  text-transform: none;
  width: auto;
  opacity: 1;
}
</style>
